import { httpPublic2 } from "@/api/public";
import type { PolicyMetaData } from "@/core/types";

export const publicRequestsTyped = {
  get_policy_metadata: function (): Promise<PolicyMetaData> {
    return httpPublic2.get("/v1/public/get_policy_metadata").json<PolicyMetaData>();
  },
};
